import { render, staticRenderFns } from "./adverNotice.vue?vue&type=template&id=e6e47d88&scoped=true"
import script from "./adverNotice.vue?vue&type=script&lang=js"
export * from "./adverNotice.vue?vue&type=script&lang=js"
import style0 from "./adverNotice.vue?vue&type=style&index=0&id=e6e47d88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e47d88",
  null
  
)

export default component.exports